import { BaseIcon } from './base';
import type { IconSmallProps } from './base';

export function IconIsEmpty(props: IconSmallProps) {
  return (
    <BaseIcon {...props}>
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M3 5C3 4.55317 3.12925 4.15859 3.38776 3.81627C3.50807 3.65268 3.65268 3.50807 3.81627 3.38776C4.15859 3.12925 4.55317 3 5 3H19C19.4467 3 19.8412 3.12917 20.1834 3.38752C20.3474 3.50806 20.4923 3.65301 20.6128 3.817C20.8709 4.15916 21 4.55349 21 5V19C21 19.4465 20.8709 19.8408 20.6128 20.183C20.4922 20.3471 20.3471 20.4922 20.183 20.6128C19.8408 20.8709 19.4465 21 19 21H5C4.55349 21 4.15916 20.8709 3.817 20.6128C3.65301 20.4923 3.50806 20.3474 3.38752 20.1834C3.12917 19.8412 3 19.4467 3 19V5ZM5 19H19V5H5V19Z"
        fill="currentColor"
      />
    </BaseIcon>
  );
}
